module.exports = __webpack_public_path__ + "static/assets/1c9b4bec6897de986287f70781d43d53.svg";